import apiClient from '../apiClient';
import { PUT_PLACE_URL } from '../apiUrl';

const putPlaceApi = (id, data) => {
  return apiClient.put(PUT_PLACE_URL(id), data);
};

export default putPlaceApi;
